import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of, throwError } from "rxjs";
import Swal from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  private active_loadings_sub: BehaviorSubject<string[]>;
  public active_loadings: Observable<string[]>;

  constructor() {
    this.active_loadings_sub = new BehaviorSubject<string[]>([]);
    this.active_loadings = this.active_loadings_sub.asObservable();
    this.check();
  }

  push_a_loading(action_name: string) {
    let exist = this.active_loadings_sub.value.filter((d) => {
      return d == action_name;
    });
    if (exist.length == 0) {
      this.active_loadings_sub.value.push(action_name);
      this.check();
    }
    // console.log("PUSHING LOADING", this.active_loadings_sub.value);
  }

  remove_a_loading(action_name: string) {
    this.active_loadings_sub.next(
      this.active_loadings_sub.value.filter((a) => {
        return a != action_name;
      })
    );
    this.check();
    // console.log("REMOVING LOADING", this.active_loadings_sub.value);
  }

  remove_all() {
    this.active_loadings_sub.next([]);
    this.check();
    // console.log("REMOVING ALL LOADINGS", this.active_loadings_sub.value);
  }

  check() {
    if (this.active_loadings_sub.value.length > 0) {
      let text =
        this.active_loadings_sub.value.length > 1
          ? " Jobs running..."
          : " Job running...";
      Swal.fire({
        title: "Loading...",
        text: this.active_loadings_sub.value.length + text,
        showCancelButton: false,
        showConfirmButton: false,
        backdrop: `rgba(0,0,123,0.4)`,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      Swal.close();
    }
  }
}
